var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import cn from 'classnames';
import withStyles from '../../core/withStyles';
import Typography from '../../internal/Typography';
import styles from './Heading1.styles';
export const Heading1 = (_a) => {
    var { children, classes, className } = _a, props = __rest(_a, ["children", "classes", "className"]);
    return (_jsx(Typography, Object.assign({ className: cn(classes.root, className), tag: "h1" }, props, { children: children })));
};
export default withStyles(styles)(Heading1);
//# sourceMappingURL=Heading1.js.map